import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
export var bounceOut = {
  0: {
    opacity: 1,
    scale: 1
  },
  0.2: {
    scale: 0.9
  },
  0.5: {
    opacity: 1,
    scale: 1.11
  },
  0.55: {
    scale: 1.11
  },
  1: {
    opacity: 0,
    scale: 0.3
  }
};

if (typeof bounceOut !== 'undefined' && bounceOut && bounceOut === Object(bounceOut) && Object.isExtensible(bounceOut) && !bounceOut.hasOwnProperty('__filemeta')) {
  Object.defineProperty(bounceOut, '__filemeta', {
    configurable: true,
    value: {
      name: "bounceOut",
      filename: "node_modules/react-native-animatable/definitions/bouncing-exits.js"
    }
  });
}

export var bounceOutUp = {
  0: {
    opacity: 1,
    translateY: 0
  },
  0.2: {
    opacity: 1,
    translateY: -10
  },
  0.4: {
    translateY: 20
  },
  0.45: {
    translateY: 20
  },
  0.55: {
    opacity: 1
  },
  1: {
    opacity: 0,
    translateY: -800
  }
};

if (typeof bounceOutUp !== 'undefined' && bounceOutUp && bounceOutUp === Object(bounceOutUp) && Object.isExtensible(bounceOutUp) && !bounceOutUp.hasOwnProperty('__filemeta')) {
  Object.defineProperty(bounceOutUp, '__filemeta', {
    configurable: true,
    value: {
      name: "bounceOutUp",
      filename: "node_modules/react-native-animatable/definitions/bouncing-exits.js"
    }
  });
}

export var bounceOutDown = {
  0: {
    opacity: 1,
    translateY: 0
  },
  0.2: {
    opacity: 1,
    translateY: 10
  },
  0.4: {
    translateY: -20
  },
  0.45: {
    translateY: -20
  },
  0.55: {
    opacity: 1
  },
  1: {
    opacity: 0,
    translateY: 800
  }
};

if (typeof bounceOutDown !== 'undefined' && bounceOutDown && bounceOutDown === Object(bounceOutDown) && Object.isExtensible(bounceOutDown) && !bounceOutDown.hasOwnProperty('__filemeta')) {
  Object.defineProperty(bounceOutDown, '__filemeta', {
    configurable: true,
    value: {
      name: "bounceOutDown",
      filename: "node_modules/react-native-animatable/definitions/bouncing-exits.js"
    }
  });
}

export var bounceOutRight = {
  0: {
    opacity: 1,
    translateX: 0
  },
  0.2: {
    opacity: 1,
    translateX: 10
  },
  0.4: {
    translateX: -20
  },
  0.45: {
    translateX: -20
  },
  0.55: {
    opacity: 1
  },
  1: {
    opacity: 0,
    translateX: 600
  }
};

if (typeof bounceOutRight !== 'undefined' && bounceOutRight && bounceOutRight === Object(bounceOutRight) && Object.isExtensible(bounceOutRight) && !bounceOutRight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(bounceOutRight, '__filemeta', {
    configurable: true,
    value: {
      name: "bounceOutRight",
      filename: "node_modules/react-native-animatable/definitions/bouncing-exits.js"
    }
  });
}

export var bounceOutLeft = {
  0: {
    opacity: 1,
    translateX: 0
  },
  0.2: {
    opacity: 1,
    translateX: -10
  },
  0.4: {
    translateX: 20
  },
  0.45: {
    translateX: 20
  },
  0.55: {
    opacity: 1
  },
  1: {
    opacity: 0,
    translateX: -600
  }
};

if (typeof bounceOutLeft !== 'undefined' && bounceOutLeft && bounceOutLeft === Object(bounceOutLeft) && Object.isExtensible(bounceOutLeft) && !bounceOutLeft.hasOwnProperty('__filemeta')) {
  Object.defineProperty(bounceOutLeft, '__filemeta', {
    configurable: true,
    value: {
      name: "bounceOutLeft",
      filename: "node_modules/react-native-animatable/definitions/bouncing-exits.js"
    }
  });
}